export const navList = [{
    label: "政策法规",
    path: "/policies",
    disabled: true,
}, {
    label: "海关",
    path: "/policies/customs"
}, {
    label: "税务",
    path: "/policies/lawsTax"
}, {
    label: "外管局",
    path: "/policies/outer"
}]


// WEBPACK FOOTER //
// ./src/model/policies.js